





import Icon from './Icon.vue';
import { iconClassEnum } from '../enums/iconClassEnum';

export default {
  name: 'PlayButton',
  components: { Icon },
  props: {
    disabled: { type: Boolean, default: false },
  },
  setup() {
    return {
      iconClassEnum,
    };
  },
};
